export default "__VITE_ASSET__3fc492d2__"